"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mStable = void 0;
const mStable_mAsset_abi_json_1 = __importDefault(require("../../abi/mStable-mAsset.abi.json"));
const mStable_Pool_abi_json_1 = __importDefault(require("../../abi/mStable-Pool.abi.json"));
const adapter_1 = __importDefault(require("./adapter"));
const dex_types_1 = require("./dex-types");
class mStable extends adapter_1.default {
    constructor(network, web3Provider, augustus) {
        super(network, web3Provider, augustus);
        this.network = network;
        this.web3Provider = web3Provider;
        this.augustus = augustus;
    }
    static getDexData(optimalRate, name) {
        const { srcAmount, data: { exchange, opType, isAssetContract }, } = optimalRate;
        return {
            destAmount: '1',
            name,
            srcAmount,
            exchange,
            opType,
            isAssetContract,
        };
    }
    getSwapFn(srcToken, destToken, data) {
        const { exchange, opType, isAssetContract } = data;
        const mStableC = new this.web3Provider.eth.Contract(isAssetContract ? mStable_mAsset_abi_json_1.default : mStable_Pool_abi_json_1.default, exchange);
        switch (opType) {
            case dex_types_1.mStableOpTypes.Mint:
                return mStableC.methods.mint(srcToken, data.srcAmount, data.destAmount, this.augustus._address);
            case dex_types_1.mStableOpTypes.Swap:
                return mStableC.methods.swap(srcToken, destToken, data.srcAmount, data.destAmount, this.augustus._address);
            case dex_types_1.mStableOpTypes.Redeem:
                return mStableC.methods.redeem(destToken, data.srcAmount, data.destAmount, this.augustus._address);
            default:
                throw new Error(`Can not build swap for OpType ${opType}`);
        }
    }
    _swap(srcToken, destToken, data) {
        const { exchange } = data;
        const swapData = this.getSwapFn(srcToken, destToken, data).encodeABI();
        return super.swap(srcToken, destToken, data, swapData, exchange);
    }
    tokenToTokenSwap(srcToken, destToken, data) {
        return __awaiter(this, void 0, void 0, function* () {
            return this._swap(srcToken, destToken, data);
        });
    }
}
exports.mStable = mStable;
//# sourceMappingURL=mStable.js.map